import type { Action, StoreActionApi } from 'react-sweet-state';
import type { ColumnMap, State } from '../../../../common/types';

export type SetUnmappedColumnsNotIncludedAction = () => Action<State, void, void>;

export const setUnmappedColumnsNotIncluded =
	() =>
	({ setState, getState }: StoreActionApi<State>) => {
		const { mappingState } = getState();
		if (mappingState === null) return;

		const columns: ColumnMap = {};

		mappingState.columnOrder.forEach((name) => {
			columns[name] = {
				...mappingState.columns[name],
				isIncluded: !!mappingState.columns[name].field,
			};
		});

		setState({
			mappingState: {
				...mappingState,
				columns,
			},
		});
	};
